import React, {Component} from 'react';
import {i18n} from "../../../config";
import settingsApi from "../../../apiV2/settingsApi";

export default class LayersPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            button: false,
            basemap: '',
            layers: [],
            savedLayers: [],
            customLayers: []
        };
    }

    componentDidMount() {
        this.props.view.ui.add("layers-panel", 'top-right');
        var customLayers = this.props.customLayers;
        if (localStorage.getItem('user_token')) {
            settingsApi.getUserSetting('layer_list_state').then(result => {
                if (result.data) {
                    this.setState({
                        savedLayers: result.data
                    }, () => {
                        //find custom layer in saved layers
                        if(customLayers != this.props.customLayers){
                            customLayers = this.props.customLayers;
                        }
                        if(customLayers){
                            for (let i = 0; i < this.state.savedLayers.length; i++) {
                                const element = this.state.savedLayers[i];
                                let customLayerIndex = this.props.customLayers.findIndex(layer => layer.name === element.id);
                                if(customLayerIndex > -1){
                                    if(this.props.autoLoadCustomLayersByNames && this.props.autoLoadCustomLayersByNames.includes(this.props.customLayers[customLayerIndex].name)){
                                        customLayers[customLayerIndex].visible = true;
                                    }else{
                                        customLayers[customLayerIndex].visible = element.visible;
                                    }
                                }
                            }
                        }
                        this.setState({
                            basemap: this.props.map.basemap.id,
                            layers: this.getLayers(this.props.map.layers.items),
                            customLayers: (customLayers) ? this.getCustomLayers(customLayers) : [],
                        }, () => {
                            this.props.showCustomLayers(this.getCustomLayers(this.state.customLayers, true));
                        });
                    });
                }
                else{
                    if(customLayers != this.props.customLayers){
                        customLayers = this.props.customLayers;
                    }
                    this.setState({
                        basemap: this.props.map.basemap.id,
                        layers: this.getLayers(this.props.map.layers.items),
                        customLayers: (customLayers) ? this.getCustomLayers(customLayers) : [],
                    }, () => {
                        this.props.showCustomLayers(this.getCustomLayers(this.state.customLayers, true));
                    });
                }
            });
        }
        else{
            this.setState({
                basemap: this.props.map.basemap.id,
                layers: this.getLayers(this.props.map.layers.items),
                customLayers: (customLayers) ? this.getCustomLayers(customLayers) : [],
            }, () => {
                this.props.showCustomLayers(this.getCustomLayers(this.state.customLayers, true));
            });
        }

    }

    componentWillReceiveProps(nextProps, nextContext) {
        let layers = this.getLayers(nextProps.map.layers.items);
        let layersChanged = false;
        let customLayers = this.state.customLayers;
        if(nextProps.customLayers !== this.props.customLayers){
            customLayers = this.getCustomLayers(nextProps.customLayers);
            layersChanged = true;
        }
        this.setState({
            layers,
            customLayers: customLayers,
        }, () => {
            if(layersChanged){
                this.props.showCustomLayers(this.getCustomLayers(this.state.customLayers, true));
            }
        })
    }

    componentWillUnmount() {
        this.props.view.ui.remove('layers-panel');
    }

    getLayers = (layers) => {
        return layers
            .filter(layer => layer.listMode !== 'hide')
            .map(layer => {
                let subLayers = (layer.layers && layer.layers.length > 0)
                    ? layer.layers.items
                        .filter(subLayer => subLayer.listMode !== 'hide')
                        .map(subLayer => ({
                            id: subLayer.id,
                            title: subLayer.title,
                            visible: subLayer.visible
                        }))
                    : [];

                return {
                    id: layer.id,
                    title: layer.title,
                    visible: layer.visible,
                    length: subLayers.length,
                    showSubLayers: false,
                    subLayers,
                };
            });
    };

    getCustomLayers = (layers, skipHidden = false) => {
        return layers
            .filter(cLayer => !skipHidden || cLayer.visible || (this.props.autoLoadCustomLayersByNames && this.props.autoLoadCustomLayersByNames.includes(cLayer.name)))
            .map(cLayer => {
                let mapLayerGroup = this.props.map.allLayers.find(l => l.id === cLayer.name);
                let subLayers = (cLayer.subLayers && cLayer.subLayers.length > 0)
                    ? cLayer.subLayers
                        .filter(subLayer => !skipHidden || subLayer.visible)
                        .map(subLayer => {
                            let mapSubLayer = (mapLayerGroup) ? mapLayerGroup.findLayerById(String(subLayer.id)) : null;
                            let data = {
                                id: subLayer.id,
                                title: subLayer.name || subLayer.title || '',
                                subType: subLayer.subType,
                                visible: (mapSubLayer) ? mapSubLayer.visible : (subLayer.visible || false),
                                type: subLayer.type,
                                icon: subLayer.icon,
                                color: subLayer.color,
                                url: subLayer.url,
                                urlParams: subLayer.urlParams,
                                colors: subLayer.colors,
                                popupTemplate: subLayer.popupTemplate,
                                renderer: subLayer.renderer,
                            };
                            if(cLayer.name === 'objects'){
                                let objectData = {
                                    useServiceIntensityColors: subLayer.useServiceIntensityColors,
                                    serviceClassAssigned1: subLayer.serviceClassAssigned1,
                                    serviceClassAssigned2: subLayer.serviceClassAssigned2,
                                    serviceClassAssigned3: subLayer.serviceClassAssigned3,
                                    serviceClassAssigned4: subLayer.serviceClassAssigned4,
                                    serviceClassReal1: subLayer.serviceClassReal1,
                                    serviceClassReal2: subLayer.serviceClassReal2,
                                    serviceClassReal3: subLayer.serviceClassReal3,
                                    serviceClassReal4: subLayer.serviceClassReal4,
                                };
                                data = Object.assign(data, objectData);
                            }
                            return data
                        })
                    : [];
                return {
                    id: cLayer.name,
                    name: cLayer.name,
                    title: cLayer.name ? i18n.t('common:sidebar.' + cLayer.name) : cLayer.title,
                    visible: (mapLayerGroup) ? mapLayerGroup.visible : (cLayer.visible || false),
                    length: subLayers.length,
                    showSubLayers: cLayer.showSubLayers || false,
                    colors: cLayer.problemStateColors || cLayer.colors,
                    filter: cLayer.filter,
                    isCustom: true,
                    subLayers
                };
            })
    };

    handleSwitchBaseLayer = (map) => {
        this.props.map.basemap = map;
        this.setState({
            basemap: map.id
        });
    };

    handleCheckShowSubLayers = (targetLayer) => {
        let layers = (targetLayer.isCustom) ? this.state.customLayers : this.state.layers,
            existingLayer = layers.find(layer => layer.id === targetLayer.id);
        if (existingLayer)
            return existingLayer.showSubLayers;

        return false;
    };

    handleToggleLayerGroup = (targetLayer) => {
        let layers = (targetLayer.isCustom) ? this.state.customLayers : this.state.layers,
            existingLayer = layers.find(layer => layer.id === targetLayer.id);
        if (existingLayer)
            existingLayer.showSubLayers = !existingLayer.showSubLayers;

        this.setState(targetLayer.isCustom ? {customLayers: layers} : {layers: layers});
    };

    updateSavedLayers = (layer) => {
        if (localStorage.getItem('user_token')) {
            let savedLayers = this.state.savedLayers;
            let isFound = false;

            for (let savedLayer of savedLayers) {
                if (savedLayer.id === layer.id) {
                    savedLayer.visible = !layer.visible;
                    isFound = true;
                    break;
                }
            }

            if (!isFound) {
                savedLayers.push({
                    id: layer.id,
                    visible: !layer.visible
                })
            }

            settingsApi.setUserSetting('layer_list_state', savedLayers).then(result => {
                if(result.data){
                this.setState({
                    savedLayers: result.data,
                });
            }
            });
        }
    }

    handleDisplayLayer = (layer, subLayer) => {
        this.updateSavedLayers(layer);
        if (subLayer) {
            subLayer.visible = !subLayer.visible;

            if (subLayer.visible) {
                layer.visible = true;
            }

        } else {
            layer.visible = !layer.visible;
        }

        let layers = this.state.layers;

        for (let item of layers) {
            if (item.id === layer.id) {
                if (!subLayer) {
                    item.visible = !layer.visible;
                    for (let subLayerItem of item.subLayers) {
                        subLayerItem.visible = !layer.visible;
                    }
                } else {
                    for (let subLayerItem of item.subLayers) {
                        if (subLayerItem === subLayer) {
                            subLayerItem.visible = !subLayerItem.visible;
                        }
                    }
                }
            }
        }

        this.setState({layers});
    };

    handleDisplayCustomLayer = (layer, subLayer) => {
        let customLayers = this.state.customLayers;
        this.updateSavedLayers(layer);
        for (let item of customLayers) {
            if (item.id === layer.id) {
                let mapLayerGroup = this.props.map.allLayers.find(l => l.id === layer.id);
                if (!subLayer) {
                    item.visible = !layer.visible;
                    if (mapLayerGroup) mapLayerGroup.visible = item.visible;
                    for (let subLayerItem of item.subLayers) {
                        subLayerItem.visible = layer.visible;
                        if (mapLayerGroup) {
                            let mapSubLayer = mapLayerGroup.findLayerById(String(subLayerItem.id));
                            if (mapSubLayer) {
                                mapSubLayer.visible = subLayerItem.visible;
                            }
                        }
                    }
                } else {
                    for (let subLayerItem of item.subLayers) {
                        if (subLayerItem === subLayer) {
                            subLayerItem.visible = !subLayerItem.visible;
                            if (mapLayerGroup) {
                                let mapSubLayer = mapLayerGroup.findLayerById(String(subLayerItem.id));
                                if (mapSubLayer) {
                                    mapSubLayer.visible = subLayerItem.visible;
                                }
                            }

                            if (subLayerItem.visible) {
                                item.visible = true;
                                if (mapLayerGroup) mapLayerGroup.visible = true;
                            }
                        }
                    }
                }
            }
        }
        this.setState({
            customLayers,
        }, () => {
            this.props.showCustomLayers(this.getCustomLayers(this.state.customLayers, true));
        });
    };

    render() {
        let mapLayers = (this.props.map) ? this.props.map.layers.items.filter(layer => layer.listMode !== 'hide') : [],
            layers = mapLayers.concat(this.state.customLayers);

        return (
            <div>
                <div id="layers-panel" className="esri-component esri-widget esri-widget--panel">
                    <ul className='esri-basemap-gallery__item-container mb-2'>
                        {this.props.maps && this.props.maps.map(map => {
                            return (
                                <li key={map.id}
                                    className={this.state.basemap === map.id
                                        ? 'esri-basemap-gallery__item esri-basemap-gallery__item--selected'
                                        : 'esri-basemap-gallery__item'
                                    }
                                    onClick={() => this.handleSwitchBaseLayer(map)}>
                                    {map.title}
                                </li>
                            )
                        })}
                    </ul>
                    <ul className='esri-layer-list__list esri-layer-list__list--root esri-layer-list__list--independent'>
                        {layers.map(layer => {
                            let subLayers = layer.isCustom ? layer.subLayers : (layer.layers ? layer.layers.items : []);
                            return (
                                <li key={layer.id}
                                    className='esri-layer-list__item esri-layer-list__item--has-children'>
                                    <div className='esri-layer-list__item-container'>
                                        {subLayers.length > 0 &&
                                        <span aria-hidden="true"
                                              onClick={() => this.handleToggleLayerGroup(layer)}
                                              className={this.handleCheckShowSubLayers(layer)
                                                  ? "esri-layer-list__child-toggle-icon--opened esri-icon-down-arrow"
                                                  : "esri-layer-list__child-toggle-icon--closed esri-icon-right-triangle-arrow"}
                                        />
                                        }
                                        <span
                                            onClick={() => layer.isCustom ? this.handleDisplayCustomLayer(layer) : this.handleDisplayLayer(layer)}
                                            className="esri-layer-list__item-toggle">
                                            {layer.visible
                                                ? <span className="esri-layer-list__item-toggle-icon esri-icon-visible"
                                                        aria-hidden="true"/>
                                                : <span
                                                    className="esri-layer-list__item-toggle-icon esri-icon-non-visible"
                                                    aria-hidden="true"/>
                                            }
                                        </span>
                                        {layer.title}
                                    </div>
                                    {subLayers.length > 0 && this.handleCheckShowSubLayers(layer) &&
                                    <ul className='esri-layer-list__list esri-layer-list__list--root esri-layer-list__list--independent'>
                                        {subLayers.filter(subLayer => subLayer.listMode !== 'hide').map(subLayer => (
                                            <li key={subLayer.id} className='esri-layer-list__item'>
                                                <div className={'esri-layer-list__item-container'}>
                                                    <span
                                                        onClick={() => layer.isCustom ? this.handleDisplayCustomLayer(layer, subLayer) : this.handleDisplayLayer(layer, subLayer)}
                                                        className="esri-layer-list__item-toggle">
                                                        {subLayer.visible
                                                            ? <span
                                                                className="esri-layer-list__item-toggle-icon esri-icon-visible"
                                                                aria-hidden="true"/>
                                                            : <span
                                                                className="esri-layer-list__item-toggle-icon esri-icon-non-visible"
                                                                aria-hidden="true"/>
                                                        }
                                                    </span>
                                                    {subLayer.title}
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                    }
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        )
    }
}
